interface FieldErrorProps {
  id?: string;
  message?: string | null;
}

/** Screen-reader-friendly inline error (announced via aria-live). */
export function FieldError({ id, message }: FieldErrorProps) {
  return (
    <div id={id} role="alert" aria-live="polite" className="min-h-[1.25rem]">
      {message ? (
        <p className="mt-2 text-sm font-medium text-red-600">{message}</p>
      ) : null}
    </div>
  );
}
